import { GridColDef } from '@mui/x-data-grid-pro';
import { ParsedDate } from '@api/Trinium/types';
import { ItemLocationHistory } from '@api/Trinium/Endpoints/Consignment/types';
import ItemLocationHistoryMobileItem from './ItemLocationHistoryMobileItem';

import styles from './DataGrid.ItemLocationHistory.module.css';

export const itemLocationHistoryColumnDefinitions: GridColDef<ItemLocationHistory>[] = [
	{
		field: 'legId'
	},
	{
		field: 'desc',
		width: 200,
		headerName: 'Description',
		headerClassName: styles['grid-column-header'],
		cellClassName: styles['grid-column'],
		renderCell: ({ row }) => <span className={styles['table-cell-pre']}>{row.desc}</span>,
		sortable: false,
		disableReorder: true
	},
	{
		field: 'typeId',
		width: 60,
		headerName: 'Loc',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'xLoc',
		width: 120,
		headerName: 'X',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'yLoc',
		width: 120,
		headerName: 'Y',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'zLoc',
		width: 120,
		headerName: 'Z',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'action',
		width: 150,
		headerName: 'Action',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'actionDesc',
		width: 250,
		headerName: 'Details',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'usrCode',
		width: 60,
		headerName: 'User',
		headerClassName: styles['grid-column-header'],
		sortable: false,
		disableReorder: true
	},
	{
		field: 'timestamp',
		width: 150,
		headerName: 'Action Date & Time',
		renderCell: ({ row }) => <span title={row.timestamp?.dateTime}>{row.timestamp?.dateTime}</span>,
		sortable: false,
		hideSortIcons: true,
		sortComparator: (v1: ParsedDate, v2: ParsedDate) => v1.unix - v2.unix,
		disableReorder: true
	}
];

export const mobileItemLocationHistoryColumnDefs: GridColDef<ItemLocationHistory>[] = [
	{
		field: 'legId'
	},
	{
		field: 'Mobile Card',
		flex: 1,
		renderCell: ({ row }) => <ItemLocationHistoryMobileItem itemHistory={row} />
	}
];
